'use strict';

/**.
 * Add opacity to HEX color.
 * The calculation works by converting the opacity number to a 2-digit HEX value
 * and appending it to the base HEX color. The resulting value is an 8-character
 * HEX color string that includes the opacity.
 *
 * @param color - HEX color.
 * @param opacity - Opacity number from 0 to 99.
 * @throws Out of range error.
 */ const opacity = (color, opacity)=>{
    if (opacity < 0 || opacity > 99) {
        throw new Error('Opacity out of range (0-99)');
    }
    return `${color}${Math.round(opacity * 255 / 100).toString(16).padStart(2, '0')}`;
};

exports.opacity = opacity;
//# sourceMappingURL=index.js.map
